import { useTranslation } from 'react-i18next';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

type Props = {
	openModal: () => void;
};

export const ChannelsButton = ({ openModal }: Props) => {
	const { t } = useTranslation('button');

	return (
		<Button onClick={openModal} variant="secondary" modifiers={['text', 'underline', 'small']}>
			{t('check_channels')}
		</Button>
	);
};
